import API from 'src/api'
import { http } from '../boot/axios'

export default {
  GRAPHQL_URL: `${API.GRAPHQL_URL}`,
  newSurvey (payload) {
    return http.post(`${this.GRAPHQL_URL}createSurvey/`, payload).then(res => res.data)
  },
  fetchSurveys () {
    return http.get(`${this.GRAPHQL_URL}surveys`).then(res => res.data)
  },
  deleteSurvey (id) {
    return http.delete(`${this.GRAPHQL_URL}deleteSurvey/${id}`).then(res => res.data)
  },
  showSurvey (id) {
    return http.get(`${this.GRAPHQL_URL}survey/${id}`).then(res => res.data)
  },
  updateSurvey (payload) {
    return http.put(`${this.GRAPHQL_URL}survey/${payload.id}`, payload).then(res => res.data)
  },
  surveyIsPublished (payload) {
    return http.put(`${this.GRAPHQL_URL}surveyIsPublished/${payload.id}`, payload).then(res => res.data)
  },
  surveyIsArchived (payload) {
    return http.put(`${this.GRAPHQL_URL}surveyIsArchived/${payload.id}`, payload).then(res => res.data)
  },
  surveyCloning (payload) {
    return http.post(`${this.GRAPHQL_URL}surveyCloning/${payload.id}`, payload).then(res => res.data)
  },
  createItems (payload) {
    const formData = new FormData()

    formData.append('id', payload.id)
    formData.append('items', JSON.stringify(payload.items))
    formData.append('sections', JSON.stringify(payload.sections || []))

    const config = payload.config

    const fields = {
      welcome_screen: config.welcome_screen,
      welcome_message: config.welcome_message,
      comment_screen: config.comment_screen,
      comment_message: config.comment_message,
      thanks_screen: config.thanks_screen,
      thanks_message: config.thanks_message,
      link_instagram: config.link_instagram,
      link_facebook: config.link_facebook,
      link_twitter: config.link_twitter,
      link_tiktok: config.link_tiktok,
      link_youtube: config.link_youtube,
      display_mode: config.display_mode,
      geolocation_mode: config.geolocation_mode,
      selectedColor: config.selectedColor
    }

    for (const key in fields) {
      const value = fields[key]
      formData.append(key, value === null ? JSON.stringify(null) : value)
    }

    if (config.logo instanceof File) {
      formData.append('logo', config.logo)
    }

    return http.post(`${this.GRAPHQL_URL}createItems/${payload.id}`, formData).then(res => res.data)
  },
  fetchItems (id) {
    return http.get(`${this.GRAPHQL_URL}fetchItems/${id}`).then(res => res.data)
  },
  fetchItemsPreview (id) {
    return http.get(`${this.GRAPHQL_URL}fetchItemsSurveyPreview/${id}`).then(res => res.data)
  },
  fetchItemsPublic (id) {
    return http.get(`${this.GRAPHQL_URL}fetchItemsSurveyPublic/${id}`).then(res => res.data)
  },
  fetchConfigSurvey (id) {
    return http.get(`${this.GRAPHQL_URL}fetchConfigSurvey/${id}`).then(res => res.data)
  },
  surveyBytoken (token) {
    return http.get(`${this.GRAPHQL_URL}surveyBytoken/${token}`).then(res => res.data)
  },
  saveSurveyOccurrence (payload) {
    return http.post(`${this.GRAPHQL_URL}saveSurveyOccurrence/`, payload).then(res => res.data)
  },
  fetchLocationsSurveyOrganization (id) {
    return http.get(`${this.GRAPHQL_URL}fetchLocationsSurveyOrganization/${id}`).then(res => res.data)
  },
  uploadItemImage (file) {
    const formData = new FormData()
    formData.append('image', file)
    return http.post(`${this.GRAPHQL_URL}surveyItemUploadImage`, formData).then(res => res.data)
  },
  uploadResponseImage (file) {
    const formData = new FormData()
    formData.append('image', file)
    return http.post(`${this.GRAPHQL_URL}surveyUploadResponseImage`, formData).then(res => res.data)
  },
  uploadSectionImage (file) {
    const formData = new FormData()
    formData.append('image', file)
    return http.post(`${this.GRAPHQL_URL}surveyUploadSectionImage`, formData).then(res => res.data)
  }
}
